import React from "react";

const ProfileHero = ({
  profile,
  saveStatus,
  saveError,
  passwordStatus,
  metrics,
  loyaltyDescription,
  progressPercent,
  canRedeemReward,
  onRedeemReward,
  rewardVoucher,
  t,
}) => {
  const MAX_DISPLAY_NAME_LENGTH = 15;
  const MAX_EMAIL_LENGTH = 40;
  const trimmedName = profile.name?.trim() ?? "";
  const fallback = t("profilePage.hero.fallbackName", "Friend");
  const rawDisplayName = trimmedName || fallback;
  const displayName =
    rawDisplayName.length > MAX_DISPLAY_NAME_LENGTH
      ? `${rawDisplayName.slice(0, MAX_DISPLAY_NAME_LENGTH)}...`
      : rawDisplayName;
  const normalizedEmail = profile.email?.trim() ?? "";
  const displayEmail =
    normalizedEmail.length > MAX_EMAIL_LENGTH
      ? `${normalizedEmail.slice(0, MAX_EMAIL_LENGTH)}...`
      : normalizedEmail;
  return (
    <section className="profile-hero">
      <div className="profile-hero__info">
        <div className="profile-hero__copy">
          <p className="profile-hero__eyebrow">
            {t("profilePage.hero.eyebrow", "Welcome back")}
          </p>
          <h1>{displayName}</h1>
          <p className="profile-hero__email" title={profile.email}>
            {displayEmail}
          </p>
          {profile.phone ? <p className="profile-hero__phone">{profile.phone}</p> : null}
          {saveError && (
            <p className="profile-status profile-status--error" role="status">
              {saveError}
            </p>
          )}
          {saveStatus && (
            <p className="profile-status" role="status">
              {saveStatus}
            </p>
          )}
          {passwordStatus && (
            <p className="profile-status profile-status--accent" role="status">
              {passwordStatus}
            </p>
          )}

          <div className="profile-metrics">
            {metrics.map((metric) => {
              const Icon = metric.icon;
              return (
                <div className="profile-metric" key={metric.label}>
                  <Icon aria-hidden="true" />
                  <div>
                    <span>{metric.label}</span>
                    <strong>{metric.value}</strong>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      <div className="profile-hero__loyalty">
        <h2>{t("profilePage.hero.loyalty.title", "Glow Club progress")}</h2>
        <p>{loyaltyDescription}</p>
        <div className="profile-progress">
          <div className="profile-progress__track">
            <div className="profile-progress__fill" style={{ "--progress": `${progressPercent}%` }} />
          </div>
          <span className="profile-progress__label">{progressPercent}%</span>
        </div>
        {canRedeemReward && (
          <button
            type="button"
            className="profile-btn profile-btn--primary profile-btn--mini"
            onClick={onRedeemReward}
          >
            {t("profilePage.hero.loyalty.redeem", "Redeem reward")}
          </button>
        )}
        {rewardVoucher && (
          <div className="profile-voucher" role="status">
            <span className="profile-voucher__title">
              {t("profilePage.hero.loyalty.voucherTitle", "Voucher unlocked!")}
            </span>
            <span className="profile-voucher__code">{rewardVoucher}</span>
            <span className="profile-voucher__hint">
              {t(
                "profilePage.hero.loyalty.voucherHint",
                "Use this code at checkout for a €20 discount."
              )}
            </span>
          </div>
        )}
      </div>
    </section>
  );
};

export default ProfileHero;
